// extracted by mini-css-extract-plugin
export default {"box":"SellButton-module__box___3D2et","link":"SellButton-module__link___Wyd2a","button":"SellButton-module__button___nsAPo","buttonText":"SellButton-module__buttonText___M7Q1y"};